import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { Button, Stack } from "@mui/material";
import round from "lodash/round";
import type { FC } from "react";
import NumberField from "../components/numberField/NumberField";
import type { Currency } from "../data/BaseEntity";
import dayjs, { ISO_DATE_FORMAT } from "../dayjs";
import type { CostCurrency } from "./costApi";
import { useExchangeRates } from "./useExchangeRates";

interface Props {
  readonly sourceCurrency: CostCurrency;
  readonly targetCurrency: Currency;
  readonly date: string | null;
  readonly value: number | null | undefined;
  readonly onChange: (value: number | null | undefined) => void;
}

const CostExchangeRate: FC<Props> = ({ sourceCurrency, targetCurrency, date, value, onChange }) => {
  const { isLoading, exchangeRates } = useExchangeRates(targetCurrency, date);
  return (
    <Stack direction="row">
      <NumberField label={`Kurs ${sourceCurrency}/${targetCurrency}`} fullWidth value={value} onChange={onChange} />
      <Button
        loading={isLoading}
        startIcon={<CurrencyExchangeIcon />}
        title={
          date ? `Pobierz kurs z dnia ${dayjs(date, ISO_DATE_FORMAT).format("DD.MM.YYYY")}` : "Pobierz aktualny kurs"
        }
        onClick={() => {
          const exchangeRate = exchangeRates ? exchangeRates[sourceCurrency] : null;
          onChange(exchangeRate ? round(1 / exchangeRate, 4) : null);
        }}
      />
    </Stack>
  );
};

export default CostExchangeRate;
